import { Dayjs } from "dayjs";
import { NoUndefinedRangeValueType } from "rc-picker/lib/PickerInput/RangePicker";

export const calculateAverageSentimentScore = (data: any) => {
  if (!data || !data.distribution) return 0;

  const { positive = 0, neutral = 0, negative = 0 } = data.distribution;

  if (negative > positive && negative > neutral) {
    return -1;
  } else if (positive > negative && positive > neutral) {
    return 1;
  } else {
    return 0;
  }
};


 export const handleDateRangeChange = (
    dates: NoUndefinedRangeValueType<Dayjs> | null,
    fetchDataFunction: (dateRange?: [string, string], timezone?: string) => void
  ) => {
    if (dates?.[0] && dates?.[1]) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const startDate = dates[0].format("YYYY-MM-DD HH:mm:ss");
      const endDate = dates[1].format("YYYY-MM-DD HH:mm:ss");
  
      fetchDataFunction([startDate, endDate], timezone);
    } else {
      fetchDataFunction();
    }
  };
  